const CATALOGUE_MAKE_KEY_PREFIX = 'MAKE_';

/**
 * The usage endpoint returns either a catalogue key or the text the user typed. Only a key can be
 * looked up, so typed text must not trigger a request for a make the catalogue cannot know.
 */
export function isCatalogueMakeKey(value: string) {
  return value.startsWith(CATALOGUE_MAKE_KEY_PREFIX);
}
